import { Helmet } from "react-helmet-async";
import { BRAND, SITE_URL } from "../data/site";

const DEFAULT_TITLE = "Online Therapy NJ | Virtual Counseling Across New Jersey | NJ Therapy Online";
const DEFAULT_DESC =
  "Online therapy for all of New Jersey. Licensed, in-network virtual counseling for anxiety, depression, teens, couples and families in all 21 NJ counties.";

export default function SEO({ title, description, path = "/", schema, noindex = false }) {
  const fullTitle = title ? (title.includes(BRAND.name) ? title : `${title} | ${BRAND.name}`) : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const url = `${SITE_URL}${path === "/" ? "/" : path}`;
  const img = `${SITE_URL}${BRAND.ogImage}`;
  const schemas = Array.isArray(schema) ? schema : schema ? [schema] : [];

  return (
    <Helmet>
      <html lang="en" />
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={BRAND.name} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
}
